'use client'

import type { ChatAttachment } from '@/lib/ai/types'
import { FileCard } from './FileCard'
import { InvoiceCard } from './InvoiceCard'
import { InvoicesTable } from './InvoicesTable'
import { ActionCard } from './ActionCard'
import { LinkCard, PolicyChip } from './LinkCard'
import { ChartFallback } from './ChartFallback'

export { FileCard, InvoiceCard, InvoicesTable, ActionCard, LinkCard, PolicyChip, ChartFallback }
export { SuggestedPrompts } from './SuggestedPrompts'

interface Props {
  attachments: ChatAttachment[]
  /** Called when the user follows a deep-link (closes the panel). */
  onNavigate?: () => void
  /** Provided when the page can be refreshed after an action (workbench). */
  onRefresh?: (() => void) | null
}

/** Dispatch each C2 attachment to its card; unknown types fall back to a link/list. */
export function AttachmentList({ attachments, onNavigate, onRefresh }: Props) {
  if (!attachments.length) return null
  const chips = attachments.filter((a) => a.type === 'policy')
  const rest = attachments.filter((a) => a.type !== 'policy')
  return (
    <div className="mt-1 w-full space-y-2">
      {rest.map((a, i) => {
        switch (a.type) {
          case 'file':
            return <FileCard key={i} attachment={a} />
          case 'invoice':
            return <InvoiceCard key={i} attachment={a} onNavigate={onNavigate} />
          case 'invoices':
            return <InvoicesTable key={i} attachment={a} onNavigate={onNavigate} />
          case 'action':
            return <ActionCard key={i} attachment={a} onRefresh={onRefresh} />
          case 'link':
            return <LinkCard key={i} attachment={a} onNavigate={onNavigate} />
          case 'chart':
            return <ChartFallback key={i} attachment={a} />
          default:
            return a.url ? <LinkCard key={i} attachment={a} onNavigate={onNavigate} /> : <ChartFallback key={i} attachment={a} />
        }
      })}
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {chips.map((a, i) => <PolicyChip key={i} attachment={a} onNavigate={onNavigate} />)}
        </div>
      )}
    </div>
  )
}
